import { RuntimeConfigService } from "./_shared/services/services-index";
export function initConfig(configService: RuntimeConfigService): () => Promise<any> {
  return () => configService.loadConfig();
}
